import CryptoJS from 'crypto-js'
import Base64 from 'base-64'
import utf8 from 'utf8'
import { PREFIX, MODE } from './Constants'

/* API for React-front
*/

class BoardsApi {

  static prepareBody(body) {
    if (typeof body === 'object') {
      return JSON.stringify(body)
    }
    if (typeof body === 'string') {
      return body
    }
    throw Error('Unexpected type of body')
  }

  static toHex(str) {
    if (!str) return
    let strings = str.split('\n')
    let hex = ''
    strings.forEach(function (item, i) {
      if (i !== 0) hex += '0a'
      for (let i = 0; i < item.length; i++) {
        hex += '' + item.charCodeAt(i).toString(16)
      }
    });
    return hex
  }

  static getCredential(token, date) {
    return this.toHex(token) + '/' + date + '/' + MODE
  }

  static getCredentialForInvite(date) {
    return CryptoJS.enc.Hex.stringify(CryptoJS.enc.Utf8.parse(null)) + '/' + date + '/'+MODE
  }

  static getSignature(HTTPVerb, URI, dateTime, token, secret, accept, payload, isInvite, isChange) {
    let date = dateTime ? dateTime.slice(0, 10).replace(/-/g, '') : null
    let signingKey = this.getSigningKey(secret, date)
    let normalizedRequest = this.getNormalizedRequest(HTTPVerb, URI, token, dateTime, accept, payload, isInvite, isChange)
    let signingDigest = this.getSigningDigest(normalizedRequest)
    return (CryptoJS.HmacSHA256(signingDigest, signingKey)).toString()

  }

  static getNormalizedRequest(HTTPVerb, URI, token, dateTime, accept, payload, isInvite, isChange) {
    let normalizedPayload = ''
    if (payload && payload !== '') {
      normalizedPayload = this.prepareBody(payload)
    }
    let queryString = URI.indexOf('?') !== -1 ? URI.split('?').pop().toLowerCase() : ''
    URI = encodeURIComponent(URI).toLowerCase()
    let acceptLower = accept ? 'accept:' + accept.toLocaleLowerCase() + '\n' : ''
    let accessLower = ''
    if (token) {
      if (isInvite || isChange) {
        if (isInvite) {
          accessLower = 'invitation-token:' + token.toLocaleLowerCase() + '\n'
        }
        else if (isChange) {
          accessLower = 'reset-password-token:' + token.toLocaleLowerCase() + '\n'
        }
      } else {
        accessLower = 'access-token:' + token.toLocaleLowerCase() + '\n'
      }
    }
    let dateTimeLower = dateTime ? 'x-uberblik-timestamp:' + dateTime.toLowerCase() : ''
    let Headers = acceptLower + accessLower + dateTimeLower
    let timestamp = dateTime
    let envString = MODE
    let hashedPayload = CryptoJS.SHA256(normalizedPayload).toString()
    return [HTTPVerb, URI, queryString, Headers, timestamp, envString, hashedPayload].join('\n')
  }

  static getSigningKey(secret, date) {
    let dateKey = ((CryptoJS.HmacSHA256(date, 'URS' + this.toHex(secret))).toString())
    let dateEnvKey = ((CryptoJS.HmacSHA256(MODE, dateKey)).toString())
    return ((CryptoJS.HmacSHA256('urs-request', dateEnvKey)).toString())
  }

  static getSigningDigest(normalizedRequest) {
    return CryptoJS.SHA256(this.toHex(normalizedRequest)).toString()
  }

  static userPasswordEncode(user, password) {
    let rawStr = user + ':' + password
    let bytes = utf8.encode(rawStr)
    let wordArray = Base64.encode(bytes)
    return 'Basic ' + wordArray
  }

  static buildSocketUrl(token) {
    let encodedToken = token ? encodeURIComponent(token) : ''
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
    const domain = window.location.host
    return `${protocol}//${domain}${PREFIX}/opensocket?token=${encodedToken}`
  }

}

export default BoardsApi



// WEBPACK FOOTER //
// ./src/api/boardsApi.js